module.exports = __webpack_public_path__ + "static/media/Profile-PNG-Icon.d1bef577.png";